import { render, staticRenderFns } from "./CouponSendDetail.vue?vue&type=template&id=2f0dc7e3"
import script from "./CouponSendDetail.vue?vue&type=script&lang=ts"
export * from "./CouponSendDetail.vue?vue&type=script&lang=ts"
import style0 from "./CouponSendDetail.vue?vue&type=style&index=0&id=2f0dc7e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports